import React from 'react';
export function DuplicateIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M13 13V9h2v4h4v2h-4v4h-2v-4H9v-2h4z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 1H1v18h4v4h18V5h-4V1zm-2 4V3H3v14h2V5h12zM7 21V7h14v14H7z"
  }));
}